<template>
  <layout>
    <page-header :header="$t('managers.edit')" />
    <div class="content">
      <resource-form
        :id="$route.params.id"
        @saved="returnBack"
        @cancelled="returnBack"
      />
    </div>
  </layout>
</template>

<script>
import ResourceForm from './Form.vue'

const resourceBase = 'managers'

export default {
  name: 'ManagersEdit',

  components: {
    ResourceForm,
  },

  methods: {
    returnBack() {
      this.$router.push({ name: `${resourceBase}` })
    },
  },
}
</script>
